import axios from "axios";
const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';
const api = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const token = localStorage.getItem("token");
if (token) {
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

export default api;